var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocuments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336 264.13V436C336 460.3 316.95 480 293.05 480H107C83.05 480 64 460.3 64 436V172C64.0682 160.352 68.7258 149.2 76.9627 140.963C85.1995 132.726 96.3515 128.068 108 128H202.12C205.378 128.005 208.602 128.658 211.605 129.922C214.608 131.185 217.329 133.034 219.61 135.36L328.76 246.36C333.404 251.109 336.003 257.488 336 264.13V264.13Z",
    strokeWidth: 50,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200 128V236C200.088 243.399 203.067 250.469 208.299 255.701C213.531 260.933 220.601 263.912 228 264H336",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176 128V76C176.068 64.3515 180.726 53.1996 188.963 44.9627C197.2 36.7258 208.352 32.0682 220 32H314C317.276 32.0046 320.518 32.6572 323.54 33.9204C326.563 35.1836 329.305 37.0323 331.61 39.36L440.76 150.36C445.401 155.058 448.002 161.396 448 168V340C448 364.3 428.95 384 405.05 384H344",
    strokeWidth: 50,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M312 32V140C312.088 147.399 315.067 154.469 320.299 159.701C325.531 164.933 332.601 167.912 340 168H448",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.f68dd894119cfc354b7a84b786671c96.svg";
export { ForwardRef as ReactComponent };